import React, { useEffect, useState } from "react";
import { Typography } from "@mhome/ui";
import { DirectionsRun, Block } from "@mui/icons-material";

const MotionDetail1Widget = ({ widget, onValueUpdate }) => {
  const [isMotion, setIsMotion] = useState(false);

  useEffect(() => {
    if (widget?.items?.$w1) {
      setIsMotion(widget.items.$w1.value === "motion");
    }
  }, [widget]);

  const getStatusText = () => {
    return isMotion ? "motion" : "no motion";
  };

  const getMotionIcon = () => {
    return isMotion ? (
      <DirectionsRun style={{ fontSize: "1.5rem", color: "white" }} />
    ) : (
      <Block style={{ fontSize: "1.5rem", color: "white" }} />
    );
  };

  return (
    <div className="w-full flex flex-col gap-4">
      {/* Motion Status Card */}
      <div
        className="rounded-2xl px-3 py-1.5 flex items-center justify-between transition-colors duration-300"
        style={{
          height: "40px",
          backgroundColor: "hsl(var(--primary))",
          opacity: isMotion ? 1 : 0.2,
        }}
      >
        <Typography className="text-white font-bold capitalize">
          {getStatusText()}
        </Typography>
        <div className="h-8 aspect-square flex items-center justify-center flex-shrink-0">
          {getMotionIcon()}
        </div>
      </div>
    </div>
  );
};

export default MotionDetail1Widget;
